import { render, staticRenderFns } from "./ResetPasswordSendSuccessPage.vue?vue&type=template&id=27495440&"
import script from "./ResetPasswordSendSuccessPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSendSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports